import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import Dialog from './Dialog.vue'
import Confirm from './Confirm.vue'

export { Confirm }

const CDialog = class {
  constructor(props) {
    const Constructor = Vue.extend(Dialog)
    this.dialog = new Constructor({
      vuetify,
      store,
      propsData: props
    })
    // this.dialog = new Vue({
    //   vuetify,
    //   ...Dialog,
    //   propsData: props || {}
    // })
  }

  get() {
    return this.dialog.$el
  }

  open() {
    this.dialog.$mount()
  }

  append(element, get = true) {
    this.dialog.$refs.dialog_body.append(get ? element.get() : element)
  }

  appendPage(Element, props = {}) {
    console.log('appendPage', Element, props);
    const instance = new Element({
      vuetify,
      store,
      propsData: props
    })
    instance.$mount(document.getElementById(this.dialog.id))
    // Devolver la instancia permite al caller interactuar con la página
    // montada (ej. controles inyectados en el header del diálogo).
    return instance
  }

  addAction(element, first = false) {
    if (first) this.dialog.$refs.actions.prepend(element)
    else this.dialog.$refs.actions.append(element)
  }

  close() {
    this.dialog.close()
  }

  clean() {
    this.dialog.clean()
  }
}

export default CDialog
